
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Check } from 'lucide-react';

const steps = [
  { id: 1, name: 'Select Child', path: '/' },
  { id: 2, name: 'Device Detection', path: '/device-detection' },
  { id: 3, name: 'Turn Off Find My', path: '/find-my-instructions' },
  { id: 4, name: 'Install Profile', path: '/install-profile' },
  { id: 5, name: 'Confirmation', path: '/confirmation' }
];

const StepIndicator = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  const getCurrentStep = () => {
    const step = steps.find(s => s.path === currentPath);
    return step ? step.id : 1;
  };

  const currentStep = getCurrentStep();

  return (
    <div className="flex items-center justify-end">
      <nav aria-label="Progress">
        <ol className="flex items-center space-x-2">
          {steps.map((step, index) => (
            <li key={step.id} className="flex items-center">
              <div className="flex items-center">
                <div
                  className={`
                    w-5 h-5 rounded-full flex items-center justify-center text-xs font-semibold
                    ${step.id < currentStep
                      ? 'bg-blue-600 text-white'
                      : step.id === currentStep
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-200 text-gray-500'
                    }
                  `}
                >
                  {step.id < currentStep ? (
                    <Check className="w-3 h-3" />
                  ) : (
                    step.id
                  )}
                </div>
                
                {index < steps.length - 1 && (
                  <div
                    className={`
                      w-3 h-0.5 ml-2
                      ${step.id < currentStep ? 'bg-blue-600' : 'bg-gray-200'}
                    `}
                  />
                )}
              </div>
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
};

export default StepIndicator;
